import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { AppConfigurationDto, LandParcelDto, LandTitleDto, MeasureDto, MeasuringFactorDto, PurposeDto } from '@cradua/data';
import Swal from 'sweetalert2';
import { LandParcellationTableComponent } from './land-parcellation-table/land-parcellation-table.component';

@Component({
  selector: 'cradua-land-parcellation',
  templateUrl: './land-parcellation.component.html',
  styleUrls: ['./land-parcellation.component.scss']
})
export class LandParcellationComponent implements OnInit{

  @Input() activitySelectedValue: string;
  @Input() selectedLandTitle: LandTitleDto;
  @Input() purposes: PurposeDto[];
  @Input() measures: MeasureDto[];
  @Input() landParcels: LandParcelDto[];
  @Input() measuringFactors: MeasuringFactorDto[];
  @Input() appConfigs: AppConfigurationDto[];
  @Output() emitSave = new EventEmitter<LandParcelDto[]>();
  @ViewChild(LandParcellationTableComponent) child: LandParcellationTableComponent;

  landParcelForm: FormGroup;
  selectedMeasuringFactor: MeasuringFactorDto;
  selectedIndex = null;

  constructor(private fb: FormBuilder) {}

  ngOnInit(): void {
this.createLandParcel();
  }

  createLandParcel() {
 this.landParcelForm = this.fb.group({
      RowIdLinkage: null,
      SectionName: null,
      PurposeId: null,
      TotalArea: [0],
      MeasureId: null,
      Cost: [0],
      URLMap: null,
      Hectare: null,
      Acre: null,
      SqKM: null,
      SqM: null,
      SqFeet: null,
      Roods: null,
      Perche: null,
      Plot: null,
      LandTitleId: [this.selectedLandTitle.id]
    });

  }

   protected filterById = <T>(id: string, lookupId: string) =>
   (fieldName: T) => fieldName[lookupId] === id;

   protected multiplyTwoNumbers = (totalArea: number, measuringFactor: number): number =>
      totalArea != null && measuringFactor != null? totalArea * measuringFactor : 0;


  calcMeasure() {
    const selectedValue: LandParcelDto = this.landParcelForm.value;
    this.landParcelForm.patchValue({
      Acre:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.Acre).toFixed(6),
      Hectare:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.Hectares).toFixed(6),
      SqKM:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.SqKM).toFixed(6),
      SqM:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.SqM).toFixed(6),
      SqFeet:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.SqF).toFixed(6),
      Roods:  this.multiplyTwoNumbers(selectedValue.TotalArea,this.selectedMeasuringFactor.Rood).toFixed(6),
      Perche:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.Perche).toFixed(6),
      Plot:  this.multiplyTwoNumbers(selectedValue.TotalArea, this.selectedMeasuringFactor.Plot).toFixed(6),
    });
  }

  onSelectedMeasure(id: string) {
  return this.measuringFactors.find(
    this.filterById<MeasuringFactorDto>(id, "MeasureId"),
  );
  }




  onInput() {
    if(this.selectedMeasuringFactor != null) {
      this.calcMeasure();
    }
  }

  onMeasure(value: string) {
     this.selectedMeasuringFactor = this.onSelectedMeasure(value);

     if(this.selectedMeasuringFactor !== null) {
      this.calcMeasure();
     }

  }

  onPopulateUrl() {
    const selectedValue: LandParcelDto = this.landParcelForm.value;
    const appConfig = this.appConfigs.find(map => map.type === 'MyMap');
    const urlMap = selectedValue?.RowIdLinkage + appConfig?.rightvalue;
    this.landParcelForm.patchValue({URLMap: urlMap});

  }

  onEdit(value: LandParcelDto) {
    this.selectedIndex = value['index'];
    this.landParcelForm.patchValue(value);
    this.selectedMeasuringFactor = this.onSelectedMeasure(value.MeasureId);
  }

  addNew(formValue: LandParcelDto) {
    let foundLandParcels: LandParcelDto[] = [];
    if(this.landParcelForm.invalid) {
   return Swal.fire(
      'Warning!',
      'Please, you cannot add blank field',
      'warning'
    );
    }
    // if(this.selectedIndex != null) {

    //   this.child.landParcelFormArray['controls'][this.selectedIndex].patchValue(formValue);
    // } else {
    //   this.child.addLandParcel(formValue);
    // }


    foundLandParcels = this.child.landParcelArrayForm.value['LandParcels'];

    if(this.selectedIndex != null) {

      let sumAssign = 0;
      let mergeIndArray = [];
      if((foundLandParcels != null && foundLandParcels.length) || (formValue != null)) {
        this.child.landParcelFormArray['controls'][this.selectedIndex].patchValue(formValue)
       mergeIndArray =  this.child.landParcelArrayForm.value['LandParcels'];
         sumAssign = mergeIndArray
        .map((item) => item.TotalArea)
        .reduce((prev, next) => prev + next);
      }

      if(sumAssign > this.selectedLandTitle.RecTotalArea) {
        sumAssign = 0;
        this.child.landParcelFormArray['controls'][this.selectedIndex].patchValue({TotalArea: 0})
        return Swal.fire(
          'Warning!',
          'Please, assigned area cannot be greater than Row Legal Area',
          'warning'
        );
      }

      this.child.landParcelFormArray['controls'][this.selectedIndex].patchValue(formValue);
    } else {
      let sumAssign = 0;
      let mergeIndArray = [];

      if((foundLandParcels != null && foundLandParcels.length) || (formValue != null)) {
       mergeIndArray =  [formValue, ...foundLandParcels]
         sumAssign = mergeIndArray
        .map((item) => item.TotalArea)
        .reduce((prev, next) => prev + next);
      }
      if(sumAssign > this.selectedLandTitle.RecTotalArea) {
        sumAssign = 0;
        return Swal.fire(
          'Warning!',
          'Please, assigned area cannot be greater than Row Id linkage',
          'warning'
        );
      }
        this.child.addLandParcel(formValue);


    }


    this.selectedIndex = null;
    this.landParcelForm.reset()
  }

  onSubmit(){
    this.emitSave.emit(this.child.landParcelArrayForm.value['LandParcels']);
  }

  onReset() {
    this.landParcelForm.reset();
    this.selectedIndex = null;
  }


}
